import React from 'react';
import { StyleSheet, TouchableOpacity, Animated } from 'react-native';
import { useStyle } from '../styles';
const TabItem = ({ kidtoken = '', scalable = false, customStyle = {}, route, type, tabBarMode, onTabLayout, isActive, onPress, }) => {
    const { vars, style } = useStyle({
        kidtoken,
        scalable,
        customStyle,
    });
    const styles = StyleSheet.create({
        tabItem: {
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'visible',
        },
    });
    const { title, renderTabBarItem } = route;
    return (React.createElement(TouchableOpacity, { key: route.id, testID: `tabItem-${route.id}`, onLayout: onTabLayout, activeOpacity: 1, style: [
            styles.tabItem,
            tabBarMode === 'fixed' && { flex: 1 },
            style[`${type}TabItem`],
        ], onPress: onPress }, (renderTabBarItem && renderTabBarItem(isActive)) || (React.createElement(Animated.Text, { testID: `tabText-${route.id}`, style: [
            style[`${type}TabItemText`],
            {
                fontWeight: isActive
                    ? vars.kid_tab_size_text_active_weight
                    : vars.kid_tab_size_text_weight,
                color: isActive
                    ? vars.kid_tab_color_active_text
                    : vars.kid_tab_color_text,
                // 选中时文字放大1.06倍，secondary除外
                transform: type !== 'secondary'
                    ? [{ scale: isActive ? 1.06 : 1 }]
                    : undefined,
            },
            {
                fontSize: vars.kid_tab_size_text,
            }, //没有定义type时，字体大小为15
        ], 
        //设置align='center'，超出文字省略号显示
        numberOfLines: 1, ellipsizeMode: "tail" }, title))));
};
export default TabItem;
